import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ── Static imports: EN ──────────────────────────────────────
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';

// ── Static imports: FR ──────────────────────────────────────
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';

// ── Static imports: NL ──────────────────────────────────────
import nlCommon from './locales/nl/common.json';
import nlAuth from './locales/nl/auth.json';

// ── Resources ───────────────────────────────────────────────

const resources = {
  en: { common: enCommon, auth: enAuth },
  fr: { common: frCommon, auth: frAuth },
  nl: { common: nlCommon, auth: nlAuth },
};

// ── Init ────────────────────────────────────────────────────

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr', // MDU Invoicing is French-first
    defaultNS: 'common',
    ns: ['common', 'auth'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mdu-language',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });

// Sync <html lang="..."> on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Set initial lang attribute
document.documentElement.lang = i18n.language;

export default i18n;
